import { ComponentProps } from "react";
import { LoadingButton } from '@altimateai/lego'

type LoadingButtonProps = ComponentProps<typeof LoadingButton>;

interface FormSubmitProps extends Omit<LoadingButtonProps, "type" | "loading"> {
  children: React.ReactNode;
  loading?: boolean;
}

const FormSubmit = ({ children, loading = false, ...props }: FormSubmitProps) => {
  return (
    <LoadingButton
      className="al-w-full disabled:al-bg-action-gray disabled:al-border-action-gray"
      type="submit"
      loading={loading}
      {...props}
    >
      {children}
    </LoadingButton>
  );
};

export default FormSubmit;
